module.exports = __webpack_public_path__ + "static/media/demoVolunteer.251b73c9.jpg";